// extracted by mini-css-extract-plugin
export default {"container":"QsjpsUHYkqIBh67kivuA","divisionColumn":"aWvqQDKLER5XZ9R5BvHg","divisionRow":"HM1chsDbU9CrDrdeKdps","viewModeDivisionColumn":"fd0YdD3WUB4dfVcK7jXc"};